import { createSlice } from "@reduxjs/toolkit";
import isEmpty from "lodash/isEmpty";
import { ACTIVE, INACTIVE } from "pages/focusItems/enums";

const initialState = {
  loading: false, // only used while fetching data
  error: "", // only used when error occurs while fetching data
  processing: false, // used while other actions are performed. eg: delete, update
  focusItemList: [],
  focusItemListCount: 0,
  newFocusItem: {},
  init: false,
  updateSuccess: false,
  productCampaign: {
    data: [],
    loading: false,
    error: ""
  },
  page: 0,
  totalPages: 0,
  tab: ACTIVE,
  searchResult: {
    data: {},
    loading: false,
    error: ""
  }
};

const focusItemsSlice = createSlice({
  name: "focusItemsSlice",
  initialState: initialState,
  reducers: {
    fetchFocusItemList: () => {
    },
    tryFetchFocusItem: () => {
    },
    createFocusItem: () => {
    },
    updateFocusItem: () => {
    },
    deleteFocusItem: () => {
    },
    setLoading: (state) => {
      state.loading = true;
      state.error = '';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true;
      state.newFocusItem = {};
      state.updateSuccess = false;
    },
    setFocusItemsList: (state, action) => {
      const { totalPages, data, page } = action.payload
      state.focusItemList = data;
      state.loading = false;
      state.totalPages = totalPages
      state.page = page
      state.focusItemListCount = data.length
      state.init = true;
    },
    setNewFocusItem: (state, action) => {
      if (state.tab === INACTIVE) {
        state.focusItemList.unshift(action.payload);
      }
      state.newFocusItem = action.payload;
      state.processing = false;
    },
    updateBundleIdentifierFlagInList: (state, action) => {
      const { remove, id } = action.payload;

      state.focusItemList = state.focusItemList.map((focus) => ({
        ...focus,
        flash_sale: remove ? false : id === focus.id
      }));


    },
    resetFocusItem: () => initialState,
    setSuccess: (state, action) => {
      const { actionType, payload } = action.payload;
      switch (actionType) {
        case "delete":
          state.focusItemList = state.focusItemList.filter((item) => item.id !== payload);
          break;
        case "update":
          const targetObj = state.focusItemList.find((item) => item.id === payload.id);
          const index = state.focusItemList.indexOf(targetObj);
          state.focusItemList[index] = payload;
          state.updateSuccess = true;
          if (!isEmpty(state.searchResult.data))
            state.searchResult.data = payload
          break;
        default:
      }
      state.processing = false;
    },
    setProductCampaignLoading: (state, action) => {
      state.productCampaign.loading = true;
      state.productCampaign.error = "";
    },
    setActiveTab: (state, action) => {
      state.tab = action.payload.value
    },
    setIntialPage: (state, action) => {
      state.page = action.payload
    },
    setSearchData: (state, action) => {
      const { error, data } = action.payload
      if (error?.length) {
        state.searchResult.error = error
      } else {
        state.searchResult.data = data
      }
      state.searchResult.loading = false
    },
    setSearchLoading: (state, action) => {
      state.searchResult.loading = action.payload
    },
    resetSearch: (state, action) => {
      state.searchResult = { ...initialState.searchResult }
    }

  }
});

export const {
  setLoading,
  setError,
  setProcessing,
  setFocusItemsList,
  setNewFocusItem,
  setSuccess,
  setActiveTab,
  resetFocusItem,
  fetchFocusItemList,
  createFocusItem,
  updateFocusItem,
  deleteFocusItem,
  setProductCampaignLoading,
  updateBundleIdentifierFlagInList,
  setIntialPage,
  tryFetchFocusItem,
  setSearchLoading,
  setSearchData,
  resetSearch
} = focusItemsSlice.actions;
export default focusItemsSlice.reducer;
